import { render, staticRenderFns } from "./PreOrderDetail.vue?vue&type=template&id=94a45fb8"
import script from "./PreOrderDetail.vue?vue&type=script&lang=js"
export * from "./PreOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports